import { FC, useEffect, useState } from 'react';

import logger from '@eneco/common/log';
import { stripAccolades } from '@eneco/common/string';
import { useFormsPublicV2PostFormV2 } from '@eneco/dc/hooks';
import useDC from '@eneco/dc/useDC';
import { GenericFormRendering } from '@sitecore/types/manual/GenericForm';
import { SubmitHandler } from 'react-hook-form';

import CommonGenericForm from './CommonGenericForm';
import { ErrorType, FormValues, prepareRequest } from './util';

const GenericForm: FC<GenericFormRendering> = ({ fields, placeholders }) => {
  const { label, businessUnit } = useDC();
  const { error, isError, isSuccess, send } = useFormsPublicV2PostFormV2();

  const {
    senderIdOption: { value: senderId },
  } = fields;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorType, setErrorType] = useState<ErrorType | undefined>();

  useEffect(() => {
    if (!isError) return;

    logger.error('Wxd7AY', 'Failed to submit form', { error });
    setErrorType(undefined);
  }, [isError, error]);

  const submitForm: SubmitHandler<FormValues> = async values => {
    setIsSubmitting(true);

    try {
      const requestBody = prepareRequest(senderId, values);

      await send({
        businessUnit,
        formId: stripAccolades(senderId),
        label,
        requestBody,
        recaptchaEnterpriseToken: values.recaptchaToken,
      } as any); // eslint-disable-line @typescript-eslint/no-explicit-any
    } catch (error) {
      logger.error('Wxd7AY', 'Failed to submit form', { error });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CommonGenericForm
      fields={fields}
      placeholder={placeholders['jss-form']}
      placeholderName="jss-form"
      submitForm={submitForm}
      isSubmitting={isSubmitting}
      errorType={errorType}
      isSuccess={isSuccess}
    />
  );
};

export default GenericForm;
